import { render, staticRenderFns } from "./FinishPaymentAnonymo.vue?vue&type=template&id=48e169ce&"
import script from "./FinishPaymentAnonymo.vue?vue&type=script&lang=js&"
export * from "./FinishPaymentAnonymo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports